import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { useSnackbar } from '@/helpers/hooks/useSnackbar'
import { downloadHref } from '@/utils'

export interface DownloadClientsListCvsRequest {
  fileName: string
  buildingId: number
}

export const downloadClientsListCvs = async (buildingId: number) => {
  const response = await authAPI.get<Blob>(`/client/exportcsv?buildingId=${buildingId}`, {
    responseType: 'blob',
  })
  return response.data
}

export const useDownloadClientsListCvs = () => {
  const objectUrlRef = useRef<string | null>(null)
  const { displaySnackbar } = useSnackbar()

  const mutation = useMutation({
    mutationFn: async ({ fileName, buildingId }: DownloadClientsListCvsRequest) => {
      const blob = await downloadClientsListCvs(buildingId)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      displaySnackbar(error.message, true)
    },
  })

  // Note: Clean up the URL object when the hook unmounts
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
